import { IBackgroundJobEntity } from "@odata/GeneratedEntityTypes";
import {
    BackgroundJobGroupedErrors, BackgroundJobItem,
    IBackgroundJobCustomData
} from "@pages/backgroundJob/BackgroundJob.utils";

import { withPermissionContext } from "../../contexts/permissionContext/withPermissionContext";
import { FormViewForExtend, IFormViewProps } from "../../views/formView/FormView";

interface IProps extends IFormViewProps<IBackgroundJobEntity, IBackgroundJobCustomData> {
}

class BackgroundJobFormView extends FormViewForExtend<IBackgroundJobEntity, IProps> {
    static defaultProps = {
        hideButtons: true,
        formProps: {
            shouldHideAuditTrail: true,
            shouldHideVariant: true
        }
    }

    groupItemsByErrorCode(itemsFailed: BackgroundJobItem[]) {
        const result: Record<string, BackgroundJobGroupedErrors> = {};
        const seen: Record<string, Set<string>> = {};

        for (const item of itemsFailed ?? []) {
            for (const validationMessage of item.Exception?.ValidationMessages ?? []) {
                const errorCode = validationMessage.ErrorCode;

                if (!result[errorCode]) {
                    result[errorCode] = {
                        parameters: validationMessage.MessageParameters,
                        items: []
                    };

                    seen[errorCode] = new Set();
                }

                const ItemId = item.ItemId;

                if (!seen[errorCode].has(ItemId)) {
                    seen[errorCode].add(ItemId);

                    result[errorCode].items.push({
                        ItemId,
                        NumberOurs: item.NumberOurs
                    });
                }
            }
        }
        return result;
    }

    onAfterLoad = async () => {
        const result = this.props.storage.data.entity.Result;
        const params = this.props.storage.data.entity.Parameters;
        const data: IBackgroundJobCustomData = {};

        if (params) {
            const parameters = JSON.parse(params);
            data.parameters = parameters;
        }

        if (result) {
            const results = JSON.parse(result);
            const errors = this.groupItemsByErrorCode(results?.ItemsFailed);

            data.results = {
                errors,
                generalError: results.GeneralError ?? results.Error?.error,
                changed: results.ItemsChanged,
                failed: results.ItemsFailed,
                skipped: results.ItemsSkipped,
                documentTypeCode: results.DocumentTypeCode
            };
        }

        this.props.storage.setCustomData(data);
        return super.onAfterLoad();
    }
}

export default withPermissionContext(BackgroundJobFormView);